import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Home/Home';
import Contact from './Contact/Contact';
import Header from './Home/HeaderComponent/Header';
import Navbars from './Home/HeaderComponent/NavbarsComponent/Navbars';
import AOS from 'aos';
import 'aos/dist/aos.css';
import IQAC from './IQAC/Iqac';
import Report from './IQAC/Report';
import Affiliation from './About US/Affiliation';
import Vision_Mission from './About US/Vision_Mission';
import Infrastructure from './About US/infrastructure/Infrastructure';
import Overview from './About US/overview/Overview';
import Message from './About US/Message/Message';
import Gallery from './About US/Gallery/Gallery';
import Course from './Academics/Course/Course';
import Admission from './Academics/Admission';
import EnquiryForm from '../src/Apply/EnquiryForm.jsx'; 
import Latest_information from './Latest/Latest_information.jsx';
import All from './Authentication/Inform/All.jsx';
import NoticeUploadForm from './Authentication/NoticeUploadForm.jsx';
import Download from './Academics/Download/Download.jsx';
import Faculty from './Faculty/Faculty.jsx';
import FacultyDetails from './Faculty/FacultyDetails.jsx';
import NEWS from './News/News.jsx';
import Dpharmacy from './Department/Dpharmacy.jsx';
import Lab from './Department/Lab.jsx';


AOS.init({
  offset: 120, 
  delay: 0, 
  duration: 1000, 
  easing: 'ease', 
  once: false, 
  mirror: false, 
  anchorPlacement: 'top-bottom',
  loop: true,
});

function App() {
  
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);

  useEffect(() => {
    
    const timer = setTimeout(() => {
      setShowEnquiryForm(true);
    }, 10000);

    return () => clearTimeout(timer); 
  }, []);

  
  const closeModal = () => {
    setShowEnquiryForm(false); 
  };

  return (
    <Router>
      <Header />
      <Navbars />
      <Routes>
        {/* Define routes for Home, About, and Contact */}
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Iqac" element={<IQAC />} />
        <Route path="/Report" element={<Report />} />
        <Route path="/Affiliation" element={<Affiliation />} />
        <Route path="/Vision_Mission" element={<Vision_Mission />} />
        <Route path="/Infrastructure" element={<Infrastructure />} />
        <Route path="/Overview" element={<Overview />} />
        <Route path="/Message" element={<Message />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Course" element={<Course />} />
        <Route path="/Admission" element={<Admission />} />
                 <Route path="/All" element={<All/>} />
         <Route path="/Latest_information" element={<Latest_information/>} /> 
         <Route path="/NoticeUploadForm" element={<NoticeUploadForm/>} /> 
         <Route path="/Download" element={<Download/>} /> 
         <Route path="/NEWS" element={<NEWS/>} /> 
         <Route path="/Dpharmacy" element={<Dpharmacy/>} /> 
         <Route path="/Lab" element={<Lab/>} /> 
         <Route path="/Faculty" element={<Faculty/>} />  
         <Route path="/FacultyDetails/:facultyName" element={<FacultyDetails/>} />  
      </Routes>
      {showEnquiryForm && <EnquiryForm closeModal={closeModal} />}
    </Router>
  );
}

export default App;
